module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4 3v16h22V3H4zm8 14v-6h-2v6H6v-6h2V9H6V5h12v6h2V5h4v5h-2v2h2v5H12z","fill":"#b2b2b2"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-icons/tab_floorplan.svg
// module id = 720
// module chunks = 2